import React from "react";
import { Col, Row } from "react-bootstrap";
import { PencilSquare, Trash } from "react-bootstrap-icons";

const DoctorListItem = ({
    item,
    index,
    isDisabled,
    claimsSetting,
    onEdit,
    onDelete,
}) => {
    return (
        <>
            <Col xs={12} className="d-flex align-items-center justify-content-between">
                <span className="fw-bold text-800 fs-12">{`Doctor - ${index + 1}`}</span>
                {isDisabled && Number(claimsSetting?.submit) === 1 && (
                    <div className="d-flex align-items-center gap-2">
                        <PencilSquare
                            role="button"
                            size={12}
                            className="text-warning"
                            onClick={() => onEdit(item)}
                        />
                        <Trash
                            role="button"
                            size={12}
                            className="text-danger"
                            onClick={() => onDelete(item)}
                        />
                    </div>
                )}
            </Col>
            <Row>
                <Col xs={12} className="mb-1 mt-2 d-flex align-items-center gap-3">
                    <div className="text-800 fw-bold fs-12">Name:</div>
                    <div className="flex-grow-1 fw-semibold text-600 fs-12">
                        {item?.practitioner?.label || ""}
                    </div>
                </Col>
                <Col xs={12} className="mb-1 d-flex align-items-center gap-3">
                    <div className="text-800 fw-bold fs-12">Speciality:</div>
                    <div className="flex-grow-1 fw-semibold text-600 fs-12">
                        {item?.practice?.label || ""}
                    </div>
                </Col>
                <Col xs={12} className="mb-1 d-flex align-items-center gap-3">
                    <div className="text-800 fw-bold fs-12">Role:</div>
                    <div className="flex-grow-1 fw-semibold text-600 fs-12">
                        {item?.role?.careroles_name || ""}
                    </div>
                </Col>
            </Row>
            <hr />
        </>
    );
};

export default React.memo(DoctorListItem);
